<template>
  <v-dialog v-model="todosCidadesDialog" :disabled="!disabled" width="1000px" scrollable>
    <template v-slot:activator="{ on }">
      <mf-button text :disabled="!disabled" label="Ver todos" v-on:click.native="on.click" />
    </template>
    <v-card class="todos-cidades-card">
      <v-card-title>
        <span class="pa-2 table-card-title">Todos os cidades</span>
        <v-spacer />
        <span class="caption secondary-text">{{ clientesNaoResolvidos | localeString(0) }} clientes não resolvidos</span>
      </v-card-title>
      <mf-loading :loader="['todos-cidades']" :width="6" :height="130">
        <v-data-table :items="cidadesTodos" :headers="headers" :items-per-page-options="rowsPerPageArray">
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item['DES_CIDADE_SN'] }}</td>
              <td>{{ item['DES_ESTADO_SN'] }}</td>
              <td>{{ item['DES_PAIS'] }}</td>
              <td class="text-right">
                {{ item['NUM_CLIENTES_CADASTRADOS'] | localeString }}<mf-quick-actions v-if="item.COD_ID_CIDADE" v-bind="getQuickActionProps(item)" />
              </td>
              <td>
                <v-menu bottom origin="center center" transition="scale-transition">
                  <template v-slot:activator="{ on }">
                    <mf-button type="icon" icon="more_vert" color="cinza-0" v-on:click.native="on.click" />
                  </template>

                  <v-list>
                    <v-list-item @click="exportCsv(item)">
                      <v-list-item-title>Exportar .csv</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>
      </mf-loading>
    </v-card>
  </v-dialog>
</template>

<script>
import orderBy from 'lodash/orderBy'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import { createCsvFromArray } from '@/config/helpers.js'
import { criteriaGroup, personTypeCriteria, citiesCriteria } from '@/components/quick-actions/segmentationGroups.js'

export default {
  props: {
    disabled: Boolean,
    tipoPessoa: String,
    clientesNaoResolvidos: Number,
  },
  data: () => ({
    todosCidadesDialog: false,
    cidadesData: null,
  }),
  computed: {
    ...mapState({
      stateInfoCidadeFisica: (state) => state.clientes.perfilDemograficoCidadeFisica,
      stateInfoCidadeJuridica: (state) => state.clientes.perfilDemograficoCidadeJuridica,
      stateFilters: (state) => state.filters,
    }),
    infoCidade() {
      const infoCidadeArray = this.tipoPessoa === 'F' ? this.stateInfoCidadeFisica : this.stateInfoCidadeJuridica
      let array = infoCidadeArray?.map((object) => {
        if (object['DES_CIDADE_SN'] === '') {
          object['DES_CIDADE_SN'] = 'NÃO INFORMADO'
        }
        return object
      })
      return orderBy(array, 'NUM_CLIENTES_CADASTRADOS')
    },
    filter() {
      return {
        unidades: this.stateFilters.units,
        tipo_pessoa: this.tipoPessoa,
        categoria_cliente: this.stateFilters.cliente,
        fidelidade: this.stateFilters.fidelidade,
        group_field: 'cidade',
      }
    },
    headers() {
      return [
        {
          text: 'Cidade',
          value: 'DES_CIDADE_SN',
          width: '20%',
        },
        {
          text: 'Estado',
          value: 'DES_ESTADO_SN',
          width: '10%',
        },
        {
          text: 'Pais',
          value: 'DES_PAIS',
          width: '10%',
        },
        {
          text: 'Clientes',
          align: 'right',
          value: 'NUM_CLIENTES_CADASTRADOS',
          width: '25%',
        },
        {
          text: '',
          sortable: false,
        },
      ]
    },
    cidadesTodos() {
      return orderBy(this.infoCidade, ['NUM_CLIENTES_CADASTRADOS'], ['desc'])
    },
    rowsPerPageArray: () => [10, 15, 25, 50, 100, { text: 'Todos', value: -1 }],
  },
  methods: {
    ...mapWaitingActions({
      listaClientesCadastrados: 'lista-clientes-cadastrados',
    }),
    async exportCsv(cidade) {
      const nomeCidade = cidade['DES_CIDADE_SN'].toLowerCase().split(' ').join('_')
      const data = await this.listaClientesCadastrados({ tipo_pessoa: this.tipoPessoa, cidade: cidade['COD_ID_CIDADE'] })
      const arrayToExport = data?.map((clients) => ({ id: clients['NUM_CPF_CNPJ'] }))
      createCsvFromArray(arrayToExport, `cadastros_${nomeCidade}`, ['CPF/CNPJ'])
    },
    getQuickActionProps(item) {
      const segmentationGroup = (groupValues) => (quickActionFiltersCriteria) =>
        criteriaGroup([
          personTypeCriteria('F'),
          citiesCriteria(groupValues),
          ...quickActionFiltersCriteria.criteria.segments,
          ...quickActionFiltersCriteria.criteria.loyalty,
          ...quickActionFiltersCriteria.criteria.clientGroups,
        ])
      return {
        quickActionGroupId: `city-${item.COD_ID_CIDADE}`,
        shortDescription: `Clientes da(s) cidade(s)`,
        longDescription: `Clientes da(s) cidade(s)`,
        quickActionGroup: 'cities',
        quickActionGroupValue: [item.COD_ID_PAIS, item.COD_ID_ESTADO, item.COD_ID_CIDADE],
        segmentationGroup,
      }
    },
  },
}
</script>

<style lang="scss">
.todos-cidades-card {
  min-height: 260px;
}
</style>
